<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()

const baseClasses = [
  'text-new-neutral-500 border-b h-10 px-3 text-left align-middle font-normal text-xs whitespace-nowrap relative',
  'border-r border-border last:border-r-0',
  '[&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
]
</script>

<template>
  <th
    data-slot="table-head"
    :class="cn(baseClasses, props.class)"
    class="after:absolute after:right-[-1px] after:top-full after:w-px after:h-[9999px] after:bg-border last:after:hidden after:content-['']"
  >
    <slot />
  </th>
</template>
